export default __webpack_public_path__ + "static/woodSpoon-55a4eb96e6dcfbb3591a8c58c5e3058f.png";